const api = `https://${location.hostname}/cgi-bin/sfs-portal-api/api.py?mode=getauthentication`;

export default {
    authenticate() {
        const that = this;
        // Return new promise
        return new Promise(function (resolve, reject) {
            // GET request
            fetch(api)
                .then(function (response) {
                    // Return json response
                    return response.json();
                })
                .then(function (json) {
                    // Parse JSON response and check for authentication success
                    if (json.result.match(/^OK/i)) {
                        // Store user data in session storage
                        if(json.data.department.match(/^student/i)){
                            that.create_session(json.data.department, json.data.name, json.data.surname, json.data.emplid, json.data.config.login, json.data.config, json.data.username);
                        }else {
                            that.create_session(json.data.department, json.data.name, json.data.surname, json.data.employeeNumber, "Yes", json.data.config, json.data.username);
                        }
                        // Return success
                        resolve(true);
                    }else {
                        // Authentication was unsuccessful
                        that.destroy_session();
                        reject(false);
                    }
                })
                .catch(function () {
                    // API call was unsuccessful
                    that.destroy_session();
                    reject(false);
                })
        })
    },
    create_session(department, name, surname, employeeNumber, login, config, username) {
        let user = {
            "department": department,
            "name": name,
            "surname": surname,
            "employeeNumber": employeeNumber,
            "login" : login,
            "config" : config
        };

        if(username == "ckang54"){
            user["dev"] = "555555555";
        }else if(username == "reptile"){
            user["dev"] = "777777777";
        }
        // Create user session storage
        sessionStorage.setItem('user', JSON.stringify(user));
    },
    destroy_session() {
        // Destroy session storage
        sessionStorage.clear();
    },
    get_user() {
        // Return user object
        return JSON.parse(sessionStorage.getItem('user'));
    },
    is_AdminMember(){
        let user = this.get_user();
        
        if(user.department.match(/^Information Technology Services/i) || user.department.match(/Student Financial Services/i) || user.department.match(/Finance/i)){
            return true
        }

        return false;
    },
    is_Student(){ //Checks if a user is a student
        let user = this.get_user();
        if(user.department == "student"){
            return true;
        }
        return false;
    },
    is_ITS(){
        let user = this.get_user();

        if(user.department.match(/^Information Technology Services/i)){
            return true
        }

        return false;
    },
    login_enabled(){
        let user = this.get_user();

        if(user.login.match(/^No/i)){
            return false;
        }

        return true;
    }
}